import { nshiftCheckoutApi } from './checkout'

export const nshiftApi = {
  checkout: nshiftCheckoutApi
}
